import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { AlertService, AuthenticationService } from "../_services/index";
import { AdvtService } from "../_services/advt.service";
import { NotificationsService } from "angular2-notifications";
import { PusherService } from "../_services/pusher.service";
import { environment } from "../../environments/environment";
//import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { BsModalService } from "ngx-bootstrap/modal";
import { debug } from "console";
import { CognitoService } from "../_services/Cognito.service";
import { GetuserService } from "../_services/getuser.service";

@Component({
  moduleId: module.id.toString(),
  templateUrl: "login.component.html",
})
export class LoginComponent implements OnInit {
  public href: string = "";
  entryHref: "";

  status: "";
  message: "";
  model: any = {};
  modalRef: BsModalRef;
  loading = false;
  returnUrl: string;
  logoimage: any;
  minLoader: any;
  public user_id;
  public merchant_id;
  public merchant_Paypal_id;
  public Formdata: any = [];
  public location;
  public lat;
  public long;
  itemID;
  loginModal: BsModalRef;
  loginModalService: BsModalService;

  // public options = {
  //   //timeOut: 3000,
  //   showProgressBar: true,
  //   pauseOnHover: true,
  //   clickToClose: true
  // };

  public options = {
    position: ["top", "right"],
    lastOnBottom: false,
    preventDuplicates: true,
    timeout: 5000,
  };

  payment_recievedID;

  @ViewChild("template") template: TemplateRef<any>;
  onboardLink: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private _cookieService: CookieService,
    private _AdvtService: AdvtService,
    private _service: NotificationsService,
    private pusherService: PusherService,
    private modalService: BsModalService,
    private cognitoService: CognitoService,
    private getUserService:GetuserService,

  ) {
    if (_cookieService.get("remember")) {
      this.model.username = this._cookieService.get("username");
      this.model.password = this._cookieService.get("password");
      this.model.rememberme = this._cookieService.get("remember");
    }
  }

  ngOnInit(): void {
    // this.route.queryParams.subscribe((res) => {
    // });
    // if (
    //   localStorage.getItem("userid") != "" &&
    //   localStorage.getItem("merchantId") != "" &&
    //   localStorage.getItem("merchantIdInPayPal") != ""
    // ) {
    //   this.updateClientPaypal();
    // }

    this.getlocation();
    this.authenticationService.isLoggedIn();
    this.authenticationService.isSetTokenIn();
    this.authenticationService.isEntryhref();
    this.authenticationService.isCreatePaypalToken();
    this.getUserService.reset();
    this.logoimage = "../../assets/images/logomain.png";
    this.minLoader = "../../assets/images/smallLoader.gif";
    this.authenticationService.CreatePaypalToken();
    // this.authenticationService.AddPartnerResponse();
    this.AddPartnerResponse1();
    this.authenticationService.logout();
    this.returnUrl = this.router.url;
  }

  AddPartnerResponse1 = async () => {
    const response2 = await fetch(
      `${environment.sandBoxUrll}v2/customer/partner-referrals`,
      {
        method: "POST",
        headers: {
          Authorization:
            "Bearer " + localStorage.getItem("CreatePaypalTokenresp"),
          "Content-Type": "application/json",
        },
        body: `{
          "tracking_id": "test123",
          "operations": [
            {
              "operation": "API_INTEGRATION",
              "api_integration_preference": {
                "rest_api_integration": {
                  "integration_method": "PAYPAL",
                  "integration_type": "THIRD_PARTY",
                  "third_party_details": {
                    "features": [
                      "PAYMENT",
                      "REFUND"
                   ]
                  }
                }
              }
            }
          ],
          "partner_config_override": {
              "return_url": "${environment.bidjonesUrl}dashboard",
              "partner_logo_url": "https://www.seasia.com/webstatic/mktg/logo/pp_cc_mark_111x69.jpg"
          },
          "products": [
            "EXPRESS_CHECKOUT"
          ],
          "legal_consents": [
            {
              "type": "SHARE_DATA_CONSENT",
              "granted": true
            }
          ]
      }`,
      }
    ).then(async (response) => {
      const responseData = await Promise.all([response.json()]);
      this.entryHref = responseData[0].links[1].href;
      return responseData;
    });
    localStorage.setItem("AddPartnerResponse", JSON.stringify(response2));
    localStorage.setItem("AddPartnerResponse", JSON.stringify(response2));
    this.entryHref = response2[0].links[1].href;
  };

  login() {
    this.loading = true;
    if (this.model.rememberme) {
      this._cookieService.set('username', this.model.username);
      this._cookieService.set('password', this.model.password);
      this._cookieService.set('remember', this.model.rememberme);
    } else {
      this._cookieService.deleteAll();
    }
    this.authenticationService.login(this.model.username, this.model.password)
      .subscribe(
        data => {
         
          if(data.onboard_link == ""){
            this.alertService.success(data.message);
            this.router.navigate(['/dashboard']);
          }
          else{
            if (data.status === 200) {
              if((data.result.is_seller == 1 || data.result.is_buyer == 1) && (data.result.stripe_account_id =='' || data.result.stripe_account_id ==null)){
                window.location.href = environment.stripeurl+data.result.id;
              }
              else{
                this.onboardLink = data.onboard_link
              }
              
              let loggedUserID = data.result.id;
              var params = {
                current_lat: this.lat,
                seller_id: loggedUserID,
                current_lng: this.long
              }
              this._AdvtService.searchpreferenceitems(params).subscribe(res => {
              });
              this.pusherService.channel.bind('searchpreference', data => {
                const currentUser = JSON.parse(window.localStorage['currentUser']);
                const currentUserId = currentUser.result.id;
                if (currentUserId == data.message.user_id) {
                  this.itemID = data.message.item[0].id;
                  const toast = this._service.alert(data.message.message);
                  toast.click.subscribe((item_id) => {
                    this.notifyroute();
                  });
                }
              });
  
            }
            else if(data.status === 400){
              if(data.redirect_to_stripe ==1 && data.account_already ==0){
                window.location.href ='https://dashboard.stripe.com/oauth/authorize?response_type=code&client_id=ca_EhG8I0NY8m90bn6cdKPnOJGR7L5VTvQ1&scope=read_write&state='+data.user.id;
                
              }else{
                this.alertService.success(data.message);
                this.loading = false;
              }
            } 
            else {
              this.alertService.error(data.message);
              this.loading = false;
            }
          }
          
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }

  notifyroute() {
    let item_id = this.itemID;
    this.router.navigate([`/item/detail-item/${item_id}`]);
  }

  clearAlert() {
    this.alertService.clearAlert();
  }

  /**
   * function to get the geolocation
   */

  public getlocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.location = position.coords;
        this.lat = position.coords.latitude;
        this.long = position.coords.longitude;
      });
    }
  }

  /**
   * Function to open modal
   * @param template
   */
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "gray modal-md" })
    );
  }

  /**
   * function to Disbale Modal
   * @param event
   */
  crossbtn() {
    this.modalRef.hide();
  }

  backModal(event: any) {
    this.router.navigate(["/login"]);
  }
  /**
   * function to logout
   * @param event
   */
  _redirectUser(event: any) {
    setTimeout(() => {
      window.location.href = this.onboardLink;
    }, 10000);
    this.modalRef.hide();
  }

  signIn(): void {
    let $this = this;
    this.cognitoService.signIn(this.model.username, this.model.password)
      .then((reponse) => {
       $this.login();
      })
      .catch((error) => {
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts